import React from 'react';
import { motion } from 'framer-motion';
import { Clock, AlertTriangle } from 'lucide-react';
export function StorySection() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-141">
      <div className="max-w-3xl mx-auto" data-id="element-142">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-143">
          <div className="flex items-center mb-6 text-orange" data-id="element-144">
            <Clock className="w-6 h-6 mr-3" data-id="element-145" />
            <span className="font-bold tracking-widest uppercase text-sm" data-id="element-146">
              La cruda realidad
            </span>
          </div>

          <div className="pl-6 md:pl-8 border-l-4 border-orange" data-id="element-147">
            <p className="font-body text-lg md:text-xl text-charcoal leading-relaxed italic mb-6" data-id="element-148">
              Son las 4:30 AM. Estás sentado en el borde de la cama, sudando
              frío. Intentas ponerte el pantalón, pero un rayo eléctrico te
              atraviesa la espalda, cruza el glúteo y se clava en tu
              pantorrilla.
            </p>
            <p className="font-body text-lg md:text-xl text-charcoal leading-relaxed italic mb-6" data-id="element-149">
              Sabes que tienes que ir a trabajar. En este país, si no te mueves,
              no produces. Pero tu cuerpo ha dicho basta.
            </p>
            <p className="font-body text-lg md:text-xl text-crimson font-semibold leading-relaxed italic" data-id="element-150">
              El miedo a perder tu empleo es casi tan fuerte como el dolor que
              no te deja ni respirar.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-151">
          <div className="flex items-center mb-6 text-crimson" data-id="element-152">
            <AlertTriangle className="w-8 h-8 mr-3" data-id="element-153" />
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-charcoal" data-id="element-154">
              Esto no es una simple molestia
            </h2>
          </div>

          <div className="space-y-6 font-body text-lg text-warm-gray leading-[1.7]" data-id="element-155">
            <p data-id="element-156">
              El dolor de ciática es una emergencia que paraliza tu vida. No
              puedes manejar más de 15 minutos, no puedes cargar a tus hijos y,
              lo peor de todo,{' '}
              <strong className="text-charcoal" data-id="element-157">
                no puedes dormir porque no encuentras ninguna posición que te de
                paz.
              </strong>
            </p>
            <p data-id="element-158">
              Has intentado con pomadas calientes, masajes que te dejaron peor y
              botes enteros de ibuprofeno que solo te arruinan el estómago.
            </p>
            <p className="text-xl text-charcoal font-medium p-6 bg-cream rounded-lg border border-gray-200" data-id="element-159">
              El sistema de salud en Estados Unidos es demasiado caro o
              demasiado lento, y tú necesitas una solución{' '}
              <strong className="text-crimson font-bold text-2xl uppercase" data-id="element-160">
                ahora
              </strong>
              .
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}